/**
 * Restructed by he.zhikai
 * Restructed on 2017-11-10
 */
'use strict';
angular.module('topicsSummaryModule', []).controller('topicsSummaryCtrl', [
    '$scope',
    '$rootScope',
    '$q',
    '$state',
    '$timeout',
    '$stateParams',
    '$compile',
    '$sce',
    'trsHttpService',
    'planCtrModalService',
    'localStorageService',
    'commandService',
    'trsspliceString',
    'modalDialog',
    'storageListenerService',
    '$sessionStorage',
    function(
        $scope,
        $rootScope,
        $q,
        $state,
        $timeout,
        $stateParams,
        $compile,
        $sce,
        trsHttpService,
        planCtrModalService,
        localStorageService,
        commandService,
        trsspliceString,
        modalDialog,
        storageListenerService,
        $sessionStorage
    ) {
        var ue;

        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                showAdds: [], // 显示补充信息
                showAddUeditor: true, // 显示新建补充信息的输入窗口
                showEditInput: {}, // 显示补充信息的编辑窗口
                reportPanelState: [],
            };
            $scope.data = {
                format: 'yyyy-MM-dd',
                channels: ['文字', '图片', '视频', '直播', '可视化', 'H5', 'VR', '节目'],
                groupid: $stateParams.groupid,
                //  date: $stateParams.date,
                reports: [],
                typeArr: ['普通', '重要', '紧急', '敏感'],
                keyword: '',
                // username: localStorageService.get('currLoginUser'), // session改变
                username: $sessionStorage.get('currLoginUser'),
                addHtmlContent: '', // 添加补充的HTMLcontent
                editHtmlContent: '', // 编辑补充的HTMLcontent
                copyHtmlContent: '', // 临时保存的HTMLcontent
                StartTime: $stateParams.starttime,
                EndTime: $stateParams.endtime,
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            listenStorage();
        }

        /**
         * [requestData description] 请求选题列表
         * @param  {Function} callback [description] 回调函数
         * @return {[type]}            [description]
         */
        $scope.selectTime = function() {
            if (!$scope.data.StartTime && !$scope.data.EndTime) return;
            $state.go(
                'front.plan.command.reportsummary',
                { groupid: $stateParams.groupid, groupname: $stateParams.groupname, starttime: $scope.data.StartTime, endtime: $scope.data.EndTime },
                { reload: 'front.plan.command.reportsummary' }
            );
        };

        /**
         * [requestData description]
         * @param   {[type]}  callback  [callback description]
         * @return  {[type]}            [return description]
         */
        function requestData(callback) {
            commandService
                .newInvoke('queryReportByGroup', {
                    GroupId: $scope.data.groupid,
                    StartTime: $scope.data.StartTime,
                    EndTime: $scope.data.EndTime,
                    IsPass: 1,
                })
                .then(function(res) {
                    var data = res.DATA;
                    $scope.status.SELECTEDREPORTNUM = res.SELECTEDREPORTNUM;
                    if (data == undefined) {
                        $scope.data.reports = data;
                    } else {
                        $scope.data.reports = data.map(function(item) {
                            return packageOneReport(item);
                        });
                    }
                    if (!!$scope.data.reports) {
                        for (var i = 0; i < $scope.data.reports.length; i++) {
                            $scope.status.reportPanelState[i] = 'relateReport' + i;
                        }
                    }
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
        }
        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenPlan(function() {
                requestData();
                storageListenerService.removeListener('plan');
            });
        }

        /**
         * [packageOneReport description] 对每条选题数据进行处理
         * @param  {[type]} item [description] 每条选题数据
         * @return {[type]}      [description]
         */
        function packageOneReport(item) {
            item.executorlist = trsspliceString.filter(item.EXECUTOR, 'USERNAME').join('、');
            item.reptype = parseInt(item.REPORTTYPE);
            item.printType = 0;
            item.replies = item.REPLIESINFO
                ? item.REPLIESINFO.map(function(reply) {
                      return reply;
                  })
                : [];
            item.flag = item.FLAG ? item.FLAG[0] : [];
            var metaObj = item.METATYPEINFO[0];
            item.metatypeApp = metaObj.METATYPEBYAPP
                ? metaObj.METATYPEBYAPP.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYAPPOTHER ? [metaObj.METATYPEBYAPPOTHER] : []).join('、');
            item.metatypeWeb = metaObj.METATYPEBYWEB
                ? metaObj.METATYPEBYWEB.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYWEBOTHER ? [metaObj.METATYPEBYWEBOTHER] : []).join('、');
            item.metatypePaper = metaObj.METATYPEBYPAPER
                ? metaObj.METATYPEBYPAPER.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYPAPEROTHER ? [metaObj.METATYPEBYPAPEROTHER] : []).join('、');
            item.metatypeWeibo = metaObj.METATYPEBYWEIBO
                ? metaObj.METATYPEBYWEIBO.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYWEIBOOTHER ? [metaObj.METATYPEBYWEIBOOTHER] : []).join('、');
            item.metatypeWeichat = metaObj.METATYPEBYWECHAT
                ? metaObj.METATYPEBYWECHAT.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYWECHATOTHER ? [metaObj.METATYPEBYWECHATOTHER] : []).join('、');
            item.metatypeTv = metaObj.METATYPEBYTV
                ? metaObj.METATYPEBYTV.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYTVOTHER ? [metaObj.METATYPEBYTVOTHER] : []).join('、');
            item.metatypeBroadcast = metaObj.METATYPEBYBROADCAST
                ? metaObj.METATYPEBYBROADCAST.split(',')
                      .map(function(idx) {
                          return $scope.data.channels[parseInt(idx) - 1];
                      })
                      .concat(metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : [])
                      .join('、')
                : (metaObj.METATYPEBYBROADCASTOTHER ? [metaObj.METATYPEBYBROADCASTOTHER] : []).join('、');
            item.metatypeOther = metaObj.METATYPEBYOTHER;
            return item;
        }

        /**
         * [reportRightResize description] 选题右侧高度自动跟左侧对齐
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.reportRightResize = function(index) {
            $timeout(function() {
                var areaHeight = $('.summary_report_left' + index).height() + 22;
                $('.summary_report_right' + index).css({ height: areaHeight + 'px' });
                $('.summary_report_left' + index).resize(function() {
                    areaHeight = $(this).height() + 22;
                    $('.summary_report_right' + index).css({ height: areaHeight + 'px' });
                });
            });
        };

        /**
         * [printTopic description] 打印选题
         * @return {[type]} [description]
         */
        $scope.printTopic = function() {
            requestData(function() {
                openPrintModal();
            });
        };

        /**
         * [openPrintModal description] 打开打印模态框
         * @return {[type]} [description]
         */
        function openPrintModal() {
            planCtrModalService.printGroups($scope.data.reports, $stateParams.groupname, '报题');
        }

        /**
         * [searchReport description] 搜索选题
         * @return {[type]} [description]
         */
        $scope.searchReport = function($event) {
            if ($event && $event.keyCode !== 13) return;
            if (!$scope.data.EndTime) {
                modalDialog.alertType('请先选择日期范围', '', 'info', 'confirm');
                return;
            }
            if ($scope.data.keyword.length > 0) {
                searchwithKeyword();
            } else {
                requestData();
            }
        };

        /**
         * [searchwithKeyword description] 根据关键词进行搜索选题
         * @return {[type]} [description]
         */
        function searchwithKeyword(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                commandService
                    .newInvoke('querySelectedReports', {
                        SearchContent: $scope.data.keyword,
                        StartTime: $scope.data.StartTime,
                        EndTime: $scope.data.EndTime,
                    })
                    .then(function(res) {
                        var SELECTEDREPORTNUM = 0;
                        var REPORTNUM = 0;
                        angular.forEach(res, function(item) {
                            if (item.ISPASS == 1) {
                                SELECTEDREPORTNUM++;
                            }
                            item = packageOneReport(item);
                        });
                        $scope.data.reports = res;
                    });
            }
        }

        /**
         * [showAdds description] 显示补充信息
         * @param  {[type]} report [description] 当前选题
         * @return {[type]}        [description]
         */
        $scope.showAdds = function(report) {
            if ($scope.status.showAdds[report.NEWREPORTID] === true) {
                $scope.status.showAdds[report.NEWREPORTID] = !$scope.status.showAdds[report.NEWREPORTID];
                ue.destroy();
            } else {
                $scope.status.showAdds = [];
                $scope.status.showAdds[report.NEWREPORTID] = !$scope.status.showAdds[report.NEWREPORTID];
                $timeout(function() {
                    showAddUeditor();
                });
            }
            $scope.status.showEditInput = {};
            $scope.status.showAddUeditor = true;
        };
        /**
         * [showAddUeditor description] 加载添加补充信息编辑器
         * @return {[type]} [description]
         */
        function showAddUeditor() {
            if (angular.isDefined(ue) && angular.isDefined(ue.key)) {
                ue.destroy();
            }
            LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.5'], function() {
                var ueditor = '<ueditor-for-command html-content="data.addHtmlContent"></ueditor-for-command>';
                ueditor = $compile(ueditor)($scope);
                $($(angular.element(document)).find('ueditorLocation')).append(ueditor);
                ue = UE.getEditor('ueditor');
                $scope.data.copyHtmlContent = $scope.data.addHtmlContent;
            });
        }

        /**
         * [replyReport description] 发表补充
         * @param  {[type]} report [description] 当前选题
         * @return {[type]}        [description]
         */
        $scope.replyReport = function(report) {
            if (!checkContent()) {
                return;
            }
            var content = ue.getContent();
            var params = {
                ReportId: report.NEWREPORTID,
                ReplyId: 0,
                AddContent: content,
            };
            commandService.newInvoke('savePlanReplies', params).then(function(res) {
                if (res.ISSUCCESS === 'true') {
                    modalDialog.alertType(res.DETAIL, '', 'success', false, function() {
                        refreshReplys(report);
                        ue.setContent('');
                    });
                }
            });
        };

        /**
         * [checkContent description] 校验正文
         * @return {[type]} [description]
         */
        function checkContent() {
            var htmltext = ue.getContent();
            var text = ue.getContentTxt().trim();
            if (text.length === 0 && htmltext.indexOf('img') < 0) {
                modalDialog.alertType('补充内容不能为空', '', 'warning', false);
                return false;
            } else {
                return true;
            }
        }

        /**
         * [refreshReplys description] 刷新补充列表
         * @param  {[type]} report [description] 当前选题
         * @return {[type]}        [description]
         */
        function refreshReplys(report) {
            commandService.newInvoke('getPlanRepliess', { ReportId: report.NEWREPORTID }).then(function(res) {
                report.replies = res;
            });
        }

        /**
         * [showEditInput description] 显示补充信息的编辑窗口
         * @param {[type]} [reply] [description] 当前补充
         * @param  {[type]} index [description] 当前补充的序号
         * @return {[type]}       [description]
         */
        $scope.showEditInput = function(reply, index) {
            if (ue.getContent() != $scope.data.copyHtmlContent) {
                modalDialog.alertType('您还未保存已填写的内容', '是否放弃保存', 'warning', true, function() {
                    showEditInput(reply, index);
                });
            } else {
                showEditInput(reply, index);
            }
        };

        /**
         * [showEditInput description] 显示补充信息的编辑窗口方法
         * @param  {[type]} reply [description] 当前补充
         * @param  {[type]} index [description] 当前补充的序号
         * @return {[type]}       [description]
         */
        function showEditInput(reply, index) {
            $scope.status.showAddUeditor = false;
            $scope.status.showEditInput = {};
            $scope.status.showEditInput[index] = true;
            $scope.data.editHtmlContent = reply.ADDCONTENT;
            $timeout(function() {
                ue.destroy();
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.5'], function() {
                    var ueditor = '<ueditor-for-command html-content="data.editHtmlContent"></ueditor-for-command>';
                    ueditor = $compile(ueditor)($scope);
                    $($(angular.element(document)).find('ueditorLocation')).append(ueditor);
                    ue = UE.getEditor('ueditor');
                    $scope.data.copyHtmlContent = $scope.data.editHtmlContent;
                });
            });
        }

        /**
         * [deleteReply description] 删除当前补充
         * @param  {[type]} reply  [description] 当前补充
         * @param  {[type]} report [description] 当前选题
         * @return {[type]}        [description]
         */
        $scope.deleteReply = function(reply, report) {
            modalDialog.alertType('确定删除该补充吗？', '', 'warning', true, function() {
                commandService.newInvoke('delPlanReplies', { ReplyId: reply.NEWPLANREPLIESID }).then(function(res) {
                    if (res.ISSUCCESS === 'true') {
                        modalDialog.alertType(res.DETAIL, '', 'success', false, function() {
                            refreshReplys(report);
                        });
                    }
                });
            });
        };

        /**
         * [editeReply description] 确认编辑补充
         * @param  {[type]} reply  [description] 当前补充
         * @param  {[type]} report [description] 当前选题
         * @param  {[type]} index  [description] 当前补充的序号
         * @return {[type]}        [description]
         */
        $scope.editeReply = function(reply, report, index) {
            if (!checkContent()) {
                return;
            }
            var content = ue.getContent();
            var params = {
                ReportId: report.NEWREPORTID,
                ReplyId: reply.NEWPLANREPLIESID,
                AddContent: content,
            };
            commandService.newInvoke('savePlanReplies', params).then(function(res) {
                if (res.ISSUCCESS === 'true') {
                    modalDialog.alertType(res.DETAIL, '', 'success', false, function() {
                        refreshReplys(report);
                        $scope.status.showEditInput[index] = false;
                        $scope.status.showAddUeditor = true;
                        $timeout(function() {
                            showAddUeditor();
                        });
                    });
                }
            });
        };

        /**
         * [cancelEdit description] 取消编辑补充
         * @param  {[type]} index [description] 当前补充的序号
         * @return {[type]}       [description]
         */
        $scope.cancelEdit = function(index) {
            $scope.status.showEditInput[index] = false;
            $scope.status.showAddUeditor = true;
            $timeout(function() {
                showAddUeditor();
            });
        };

        /**
         * [rebackReport description] 撤回选题
         * @param  {[type]} report [description] 当前选题
         * @return {[type]}        [description]
         */
        $scope.rebackReport = function(report) {
            modalDialog.alertType('确定撤回该选题吗？', '', 'warning', true, function() {
                commandService.newInvoke('retractSelectedReport', { ReportId: report.NEWREPORTID }).then(function(res) {
                    if (res.ISSUCCESS === 'true') {
                        modalDialog.alertType(res.DETAIL, '', 'success', false, function() {
                            $scope.data.reports = $scope.data.reports.filter(function(rep) {
                                return rep.NEWREPORTID != report.NEWREPORTID;
                            });
                            if ($scope.data.reports.length === 0) {
                                $rootScope.$broadcast('refreshTopicGroups');
                            }
                        });
                    }
                });
            });
        };

        /**
         * [viewArticle description] 打开关联稿件
         * @param  {[type]} news [description] 当前关联稿件
         * @return {[type]}      [description]
         */
        $scope.viewArticle = function(news) {
            if (news.METADATAID) {
                var url = $state.href('iwopreview', { iwometadataid: news.METADATAID, iwomodalname: 'iwo.personal', iwotype: '3' });
                window.open(url);
            } else {
                window.open(news.METADATAURL);
            }
        };

        /**
         * [disconNews description] 解除当前关联稿件
         * @param  {[type]} report [description] 当前选题
         * @param  {[type]} news   [description] 当前稿件
         * @return {[type]}        [description]
         */
        $scope.disconNews = function(report, news) {
            modalDialog.alertType('确定解除该关联关系？', '', 'warning', true, function() {
                commandService
                    .newInvoke('removeMetaData', { ReportId: report.NEWREPORTID, MetaDataId: news.NEWREPORTMETADATAID })
                    .then(function(res) {
                        if (res.ISSUCCESS === 'true') {
                            modalDialog.alertType(res.DETAIL, '', 'success', true, function() {
                                requestData();
                            });
                        }
                    });
            });
        };

        /**
         * [openLinkOf description] 打开当前附件地址
         * @param  {[type]} file [description] 当前附件
         * @return {[type]}      [description]
         */
        $scope.openLinkOf = function(file) {
            if (file.REPORTAPPTYPE == 3 || file.REPORTAPPTYPE == 5) {
                //  getVideoUrl(file).then(function(data) {
                //      window.open(data);
                //  });
                getVideoUrl(file).then(function(data) {
                    var src = data.DATA.videoUrl;
                    toload(file, $sce.trustAsResourceUrl(src));
                });
            } else {
                window.open(file.REPORTAPPFILE);
            }
        };

        /**
         * [download description] 下载当前附件
         * @param  {[type]} file [description] 当前附件
         * @return {[type]}      [description]
         */
        $scope.download = function(file) {
            //  if (file.REPORTAPPTYPE == 3 || file.REPORTAPPTYPE == 5) {
            //      getVideoUrl(file).then(function(data) {
            //          var videoUrl = "/wcm/mlfcenter.do?serviceid=mlf_fusionexport&methodname=downloadFile&Url=" + data.replace(/\&token/,"%26token") + "&FileName=" + file.REPORTAPPDESC;
            //          window.open(videoUrl);
            //      });
            //  } else if (file.REPORTFILEEXT == "txt" || file.REPORTFILEEXT == "pdf" || file.REPORTAPPTYPE == "1") {
            //      var url = "/wcm/mlfcenter.do?serviceid=mlf_fusionexport&methodname=downloadFile&Url=" + file.REPORTAPPFILE + "&FileName=" + file.REPORTAPPDESC;
            //      window.open(url);
            //  } else {
            //      $scope.openLinkOf(file);
            //  }
            if (file.REPORTAPPTYPE == 3 || file.REPORTAPPTYPE == 5) {
                getVideoUrl(file).then(function(data) {
                    var src = data.DATA.videoUrl;
                    toload(file, $sce.trustAsResourceUrl(src), 'audio');
                });
            } else {
                toload(file, file.REPORTAPPFILE);
            }
        };
        /**
         * [toload description] 下载文件
         * @param  {[type]} url [description]
         * @return {[type]}     [description]
         */
        function toload(file, url, audio) {
            var $a = !!audio ? $("<a target='_blank'></a>") : $('<a></a>');
            var src = !!audio ? url + '&attname=' + file.REPORTAPPDESC : url;
            $a.attr({
                href: src,
                download: file.REPORTAPPDESC,
            });
            $a[0].click();
        }

        /**
         * [getVideoUrl description] 获取音视频地址
         * @param  {[type]} file [description] 音视频文件
         * @return {[type]}      [description]
         */
        function getVideoUrl(file) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_videoInterfacesEncapsulation',
                methodname: 'getVideoUrl',
                VideoId: file.REPORTAPPFILE,
                resourceType: file.REPORTAPPTYPE == 3 ? 'video/mp4' : 'audio/mp3',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [showFileSize description] 显示文件大小
         * @param  {[type]} size [description] 文件大小
         * @return {[type]}      [description]
         */
        $scope.showFileSize = function(size) {
            if (angular.isDefined(size) && parseInt(size) !== NaN && parseInt(size) !== 0) {
                var fileSize = parseInt(size),
                    unitArray = ['KB', 'MB', 'GB'],
                    unit = unitArray[0];
                for (var i = 0; fileSize > 1000; i++) {
                    fileSize = fileSize / 1024;
                    unit = unitArray[i + 1];
                }
                if ((fileSize + '').indexOf('.') > -1) {
                    fileSize = Math.round(fileSize * 10) / 10;
                }
                return '(' + fileSize + unit + ')';
            } else {
                return '';
            }
        };
        /**
         * [createTask description] 创建任务
         * @return {[type]}      [description]
         **/
        $scope.createTask = function(data) {
            $state.go(
                'front.plan.command.groupassignment',
                { groupid: data.GROUPID, reportid: data.NEWREPORTID },
                { reload: 'front.plan.command.groupassignment' }
            );
        };
        /**
         * [queryTaskData description] 查询任务
         * @return {[type]}      [description]
         */
        function queryTaskData(index, reportid) {
            var defer = $q.defer();
            let params = {
                serviceid: 'mlf_taskcommand',
                methodname: 'queryTasksByReportId',
                ReportId: reportid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                if (data) {
                    defer.resolve(data);
                } else {
                    defer.reject(data);
                }
            });
            return defer.promise;
        }
        /**
         * [taskDetail description] 任务详情
         * @param  {[type]} taskId [description] 任务id
         * @return {[type]}        [description]
         */
        $scope.taskDetail = function(taskId) {
            commandService.assignmentDetail(taskId);
        };
        /**
         * [editTask description] 编辑任务
         * @return {[type]}      [description]
         **/
        $scope.editTask = function(reports, taskid) {
            $state.go(
                'front.plan.command.groupassignment',
                { groupid: reports.GROUPID, reportid: reports.NEWREPORTID, taskid: taskid },
                { reload: 'front.plan.command.groupassignment' }
            );
        };
        /**
         * [clearTask description] 删除任务
         * @return {[type]}      [description]
         **/
        $scope.clearTask = function(taskid, index, reportid) {
            modalDialog.alertType('删除任务将不可恢复，是否继续？', '', 'ask', true, function() {
                commandService.newInvoke('removeTask', { TaskIds: taskid }).then(function(data) {
                    if (data.ISSUCCESS) {
                        modalDialog.alertType('删除成功', '', 'success', false, function() {
                            requestData(function() {
                                $scope.status.reportPanelState[index] = 'groupAssign' + index;
                                queryTaskData(index, reportid).then(function(data) {
                                    $scope.data.reports[index].groupAssign = data;
                                });
                            });
                        });
                    }
                });
            });
        };
        /**
         * [expansionReportPanel description] 报题选题右侧面板
         * @return {[type]}      [description]
         */
        $scope.expansionReportPanel = function(item, index, reportid) {
            if ($scope.status.reportPanelState[index] === item + index) return;
            $scope.status.reportPanelState[index] = item + index;
            if (item === 'groupAssign' && angular.isUndefined($scope.data.reports[index].groupAssign)) {
                queryTaskData(index, reportid).then(function(data) {
                    $scope.data.reports[index].groupAssign = data;
                });
            }
        };
    },
]);
